import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class NotificationsService {

    constructor(private toastr: ToastrService) { }

    success(message: string) {
        this.toastr.success(message);
    }

    info(message: string) {
        this.toastr.info(message);
    }

    error(message: string) {
        this.toastr.error(message);
    }

    errors(messages: string[]) {
        messages.forEach(message => {
            this.toastr.error(message);
        });
    }
}
